import { FC, useEffect, useState } from "react";

import { getOrg, listRegion, RegionWithSubregions } from "@rubi/api-generated";
import { useParams } from "react-router-dom";

import { DevPage, ErrorMsg, Section } from "./common";
import { RegionBreadcrumbs, RegionGrid, RegionSubNav } from "./regionShared";

export const DevRegionListPage: FC = () => {
  const { orgId = "" } = useParams();

  const [regions, setRegions] = useState<RegionWithSubregions[]>([]);
  const [activeRegionId, setActiveRegionId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      listRegion({ path: { org_id: orgId }, throwOnError: false }),
      getOrg({ path: { org_id: orgId }, throwOnError: false }),
    ]).then(([regionsResponse, orgResponse]) => {
      if (regionsResponse.status === 200) {
        setRegions(regionsResponse.data?.regions ?? []);
        setError(null);
      } else {
        setError(
          `${regionsResponse.status} ${regionsResponse.error?.console_msg ?? ""}`,
        );
      }
      if (orgResponse.status === 200) {
        setActiveRegionId(orgResponse.data?.region_id ?? null);
      }
      setLoading(false);
    });
  }, [orgId]);

  return (
    <DevPage title="Regions" breadcrumbs={<RegionBreadcrumbs orgId={orgId} />}>
      <RegionSubNav orgId={orgId} active="region" />

      <Section subtitle="Existing regions">
        <ErrorMsg msg={error} />
        <RegionGrid
          orgId={orgId}
          regions={regions}
          activeRegionId={activeRegionId}
          loading={loading}
        />
      </Section>
    </DevPage>
  );
};
